/**
 * The only analytics the free excavation selector sends.
 *
 * Every property is a fixed value, so the visitor's answers never reach
 * PostHog: the type allows no free text, and
 * __tests__/marketing/excavation-selector-behaviour.test.tsx checks the
 * payloads.
 */
export type ExcavationSelectorEvent =
  /** The visitor answered a question for the first time on this page view. */
  | { event: "excavation_selector_used" }
  /** The visitor answered every question and saw a result. */
  | { event: "excavation_selector_completed" }
  /** The visitor pressed "Print this record". */
  | { event: "excavation_selector_printed" };

interface Capture {
  capture?: (event: string, properties: Record<string, string>) => unknown;
}

export function trackExcavationSelector(
  posthog: Capture | null | undefined,
  analyticsEvent: ExcavationSelectorEvent,
): void {
  posthog?.capture?.(analyticsEvent.event, { tool: "excavation_selector" });
}
